import { render, staticRenderFns } from "./SimuladorPrincipal.vue?vue&type=template&id=5fe69f5a&scoped=true&"
import script from "./SimuladorPrincipal.vue?vue&type=script&lang=js&"
export * from "./SimuladorPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./SimuladorPrincipal.vue?vue&type=style&index=0&id=5fe69f5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe69f5a",
  null
  
)

export default component.exports